import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { PatientPaymentDetailsAbout } from "@/components/payment/patient/patient-payment-details-about";

import type { JSX } from "react";

const AboutPaymentDetailsPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton align="start" icon={Left} />
        <HeaderTitle title="Sobre" align="center" />
      </HeaderRoot>
      <Page>
        <PatientPaymentDetailsAbout />
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/patient-payments/about-payment-details",
)({
  component: AboutPaymentDetailsPage,
});
